import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from "vanilla-cookieconsent";

export const cookieConsent = CookieConsent;

// Setup data layer and default consent

window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
};

window.gtag('consent', 'default', {
    analytics_storage: 'denied',
});

const syncAnalyticsConsent = () => {
    window.gtag('consent', 'update', {
        analytics_storage: CookieConsent.acceptedCategory('analytics')
            ? 'granted'
            : 'denied',
    });
};

// Run cookie consent with config

CookieConsent.run({
    onConsent: syncAnalyticsConsent,
    onChange: syncAnalyticsConsent,
    categories: {
        necessary: {
            enabled: true,
            readOnly: true
        },
        analytics: {
            enabled: false,
            readOnly: false,
            autoClear: {
                cookies: [
                    {
                        name: /^(_ga|_gid)/
                    }
                ]
            },
        },
    },
    language: {
        default: 'en',
        translations: {
            en: {
                consentModal: {
                    title: 'This website uses cookies',
                    description: 'We use cookies on our site to improve your experience and analyse usage.',
                    acceptAllBtn: 'Allow',
                    acceptNecessaryBtn: 'Deny',
                    showPreferencesBtn: 'Customise',
                    footer: `
                <a href="/cookie-policy">Cookie Policy</a>
                <a href="/privacy-policy">Privacy Policy</a>
              `,
                },
                preferencesModal: {
                    title: 'Manage cookie preferences',
                    acceptAllBtn: 'Allow all',
                    acceptNecessaryBtn: 'Deny all',
                    savePreferencesBtn: 'Accept current selection',
                    closeIconLabel: 'Close',
                    sections: [
                        {
                            title: 'Your cookie choices',
                            description: `You may review and change your choices at any time by using the link in the footer.`,
                        },
                        {
                            title: 'Strictly Necessary',
                            description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    expires: 'Expiration',
                                    desc: 'Description'
                                },
                                body: [
                                    {
                                        name: 'cc_cookie',
                                        domain: location.hostname,
                                        expires: '182 days',
                                        desc: 'Remembers your cookie preferences.',
                                    },
                                    {
                                        name: 'CraftSessionId',
                                        domain: location.hostname,
                                        expires: 'Session',
                                        desc: 'Persists session state.',
                                    },
                                    {
                                        name: 'CRAFT_CSRF_TOKEN',
                                        domain: location.hostname,
                                        expires: 'Session',
                                        desc: 'Protects against CSRF attacks.',
                                    },
                                    {
                                        name: '*_identity',
                                        domain: location.hostname,
                                        expires: 'While logged in',
                                        desc: 'Maintains a secure, authenticated session.',
                                    },
                                    {
                                        name: '*_username',
                                        domain: location.hostname,
                                        expires: '1 year',
                                        desc: 'Remembers your username when logging in.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Embedded Content',
                            description: 'Our site contains some video content. We embed videos from Vimeo and Youtube, using Do Not Track and privacy-enhanced modes. These remaining cookies are necessary to display the videos.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    expires: 'Expiration',
                                    desc: 'Description'
                                },
                                body: [
                                    {
                                        name: 'player_clearance',
                                        domain: 'vimeo.com',
                                        expires: '7 days',
                                        desc: 'Vimeo cookie used for bot prevention.',
                                    },
                                    {
                                        name: 'cf_clearance',
                                        domain: 'vimeo.com',
                                        expires: '1 year',
                                        desc: 'Cloudflare cookie used for bot prevention.',
                                    },
                                    {
                                        name: '_cf_bm',
                                        domain: 'vimeo.com',
                                        expires: '30 minutes',
                                        desc: 'Cloudflare bot manager, manages incoming traffic that matches criteria associated with bots.',
                                    },
                                    {
                                        name: 'AEC',
                                        domain: 'youtube.com',
                                        expires: '6 months',
                                        desc: 'Detect spam, fraud, and abuse.',
                                    },
                                    {
                                        name: 'SOCS',
                                        domain: 'youtube.com',
                                        expires: '13 months',
                                        desc: 'Store a user’s state regarding their cookies choices.',
                                    },
                                    {
                                        name: '_Secure-ENID',
                                        domain: 'youtube.com',
                                        expires: '13 months',
                                        desc: 'Detect spam, fraud, and abuse.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Measurement',
                            description: 'These cookies collect information about how you use our website. All of the data is anonymised and cannot be used to identify you.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    expires: 'Expiration',
                                    desc: 'Description'
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: 'google.com',
                                        expires: '2 years',
                                        desc: 'Used by Google Analytics to generate statistical data on how you use the website.',
                                    },
                                    {
                                        name: '_gid',
                                        domain: 'google.com',
                                        expires: '2 years',
                                        desc: 'Used by Google Analytics to collect data on the number of times you have visited the website as well as dates for the first and most recent visit.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'More information',
                            description: 'For any questions in relation to these cookies and your choices, please contact us.'
                        }
                    ]
                },
            },
        },
    },
});